export default {}
export const API_URL = process.env.API_URL


// WEBPACK FOOTER //
// ./src/common/config.js